<ng-container>

  @if (isLoading) {
    <div class="diary-form-inline-loading">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  }

  @if (!isLoading) {
    <form [formGroup]="form" (submit)="onSave()">
      <div class="details-view-results-head">
        <div class="head-justified">
          <div class="head-left-col">
            <app-enable-disable-toggle
              formControlName="enabled"
              [enableLabel]="'Enable'"
              [disableLabel]="'Disable'"
              [enabledLabel]="'Enabled'"
              [disabledLabel]="'Disabled'">
            </app-enable-disable-toggle>

            <app-button
              [iconOnly]="true"
              faIcon="far fa-cog"
              type="button"
              margin="none"
              variant="info"
              (clicked)="configModal.show(diaryForm)"
            />
          </div>

          <div class="has-patient-entries" *ngIf="diaryForm && diaryForm.hasEntries">
            <strong>E-Diary Entries Submitted</strong><br>
            Changes to this form are restricted.
          </div>

          <div class="add-question-save-container">
            <app-button
              text="Remove Diary"
              type="button"
              [isBusy]="isDeleting"
              [disabled]="diaryForm?.hasEntries || isDeleting || isLastDiary"
              margin="none"
              variant="info"
              (clicked)="onRemoveDiary()" />
            <app-button
              text="Save Changes"
              type="submit"
              [isBusy]="form.get('isBusy').value"
              [disabled]="!formHasChanges || form.get('isBusy').value"
              margin="none"
              variant="primary" />
          </div>
        </div>
      </div>

      <div class="segment-add-question-container">
        <app-segment-control (segmentIndexChange)="segmentIndexChanged($event)">
          <app-segment-control-item text="Questions" [active]="true"></app-segment-control-item>
          <app-segment-control-item text="Rules" *ngIf="diaryForm?.diaryType !== DiaryType.OnboardingQuestions"></app-segment-control-item>
        </app-segment-control>

        <div style="width: 160px;" [ngClass]="{ 'visibility-hidden': currentSegment !== 0 }">
          <app-dropdown-input
            #addQuestionDropdown
            [options]="addOptions"
            [parentForm]="form"
            name="addOption"
            placeholder="+ Add Question">
          </app-dropdown-input>
        </div>

        <div [ngClass]="{ 'visibility-hidden': currentSegment !== 1 }">
          <app-button
            text="+ Add Rule"
            type="button"
            [disabled]="isAddRuleButtonDisabled()"
            margin="none"
            variant="info"
            (clicked)="addRuleModal.add(diaryForm)"
          />
        </div>
      </div>
    </form>

    <!-- Start: Questions -->
    <div style="margin-left: 30px;" [ngClass]="{ 'visibility-hidden': currentSegment !== 0 }">
      <div class="form-builder-container" *ngIf="diaryForm && diaryForm.elements.length > 0">
        <ng-container *ngFor="let element of diaryForm.elements; let i = index">
          <app-trial-diary-form-element-renderer
            [element]="element"
            [index]="i"
            [hasEntries]="diaryForm.hasEntries"
            [allElements]="diaryForm.elements"
            [showCompletionWarning]="completionWarningElements.has(element)"
            (elementMoveUp)="onMoveElementUp(i)"
            (elementMoveDown)="onMoveElementDown(i)"
            (elementRemove)="onRemoveElement(i)"
            (elementManage)="onManageElement(element)"
            (messageRemove)="onRemoveMessageFromElement(i, $event)"
            (messageAdd)="onHandleAddMessageToElement(i)"
            (messageEdit)="onHandleEditMessage(i, $event)"
            (visibilityEdit)="onHandleVisibilityEdit(i)"
          />
        </ng-container>
      </div>

      <div class="no-results inside" *ngIf="diaryForm && diaryForm.elements.length === 0">
        <div class="inner">
          <div class="image">
            <img src="assets/img/no-results-illustration.png" alt="No results found" />
          </div>
          <div class="content">
            <h2>No Questions</h2>
            <p>There are no questions assigned to this e-diary form.</p>
          </div>
        </div>
      </div>
    </div>
    <!-- End: Questions -->

    <!-- Start: Rules -->
    <div style="margin: 0 30px;" [ngClass]="{ 'visibility-hidden': currentSegment !== 1 }">
      <div class="rules-unsaved-options" *ngIf="hasUnsavedOptions()">
        You have elements with unsaved options, please save your changes to enable adding a new rule.
      </div>
      <app-trial-diary-rules [diaryForm]="diaryForm" (ruleRemoved)="onRulesUpdated()" (editRule)="addRuleModal.edit(diaryForm, $event)"></app-trial-diary-rules>
    </div>
    <!-- End: Rules -->
  }

<app-trial-diary-add-rule-modal #addRuleModal (updated)="onRulesUpdated()"></app-trial-diary-add-rule-modal>

<app-trial-diary-config-modal #configModal [diaryForm]="diaryForm" (updated)="onConfigUpdated($event)" />

<app-element-settings-modal #elementSettingsModal (updated)="onElementUpdated($event)" />

<app-confirm-action-modal #confirmRemoveElement (confirmed)="onConfirmRemoveElement($event)" />
<app-confirm-action-modal #confirmRemoveDiary (confirmed)="onConfirmRemoveDiary($event)" />

<app-element-message-modal #messageModal (added)="onHandleMessageAddedToElement($event)" (updated)="onHandleMessageUpdated($event)"></app-element-message-modal>

<app-element-visibility-modal #visibilityModal (applied)="onHandleVisibilityApplied($event)"></app-element-visibility-modal>
</ng-container>
